import React from 'react'
import {connect} from "react-redux";
import {send_dccgen_cmd} from "../etc/cmd";
import { CiPlug1 } from "react-icons/ci";
const Dccgen = ({dccgen, boosters}) => {

    const dccgen_state = parseInt(dccgen.dccgen_state | 0)

    let st = "on"
    if( dccgen_state === 0x00) {
        st = "off"
    } else if( dccgen_state === 0x01 || dccgen_state === 0x02) {
        st = "stop"
    } else if( dccgen_state === 0x03) {
        st = "on"
    }




    const onClick = () => {
        let cc = {
            id: dccgen.uid,
            state: dccgen_state > 0x02 ? 0x00 : 0x03,
        }
        send_dccgen_cmd(cc);
    }

    return (
        <>
            <div onClick={onClick} title={'' + dccgen.uid.slice(4) + " (" + dccgen.product + ") - " + st} key={dccgen.uid} className={"bubble dcc dccgen " + st}>
               <CiPlug1/>
            </div>
        < />);
}

function mapStateToProps(state, other) {
/*
    return {
        boosters: state.lcs.filter((itm) => {
            return itm.name === "dcc" && itm.booster
        }),
        dccgens: state.lcs.filter((itm) => {
            return itm.name === "dcc" && itm.dccgen
        }),
        lcs: state.lcs.filter((itm) => {
            return itm.name === "lc"
        })
    };*/

    return state
}

const mapDispatchToProps = (dispatch) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(Dccgen)